/**
 * 控制台品牌标识。
 *
 * 之前各页面各写一个 `<span className="brand__mark">I</span>` —— 一个蓝色圆角
 * 方块里塞个字母 I，是占位图，不是品牌。真正的 logo 在
 * `public/brand/logo.png`（由官网那份 `assets` 同源稿缩出来，448px 宽）。
 *
 * 为什么做成组件而不是复制五处 img：
 * 这五处（侧栏、登录 / 找回密码、重设密码的两个状态）必须始终指向**同一张图**。
 * 分散写的话，下次换 logo 只会改到其中几处，剩下的地方继续顶着旧图 ——
 * 而这种不一致在页面之间跳转时格外刺眼。
 *
 * 图里已经含 "iCetus" 字样，所以后面只跟「控制台」三个字，不再重复品牌名。
 * `alt` 仍写 iCetus：读屏时"iCetus 控制台"才是完整的一句话。
 */
export function Brand() {
  return (
    <div className="brand">
      <img
        className="brand__logo"
        src="/brand/logo.png"
        alt="iCetus"
        width={134}
        height={24}
        /* 尺寸写死是给布局预留位置用的：图没加载完之前侧栏不会先塌再撑开。
           真实值由 CSS 控制，换 logo 只需改 CSS 里的 block-size */
        decoding="async"
      />
      <span>控制台</span>
    </div>
  );
}
